import { createSlotRecipe } from './runtime';

const radioButtonGroupConfig = {"name":"radioButtonGroup","slots":["root","label","item","itemText","itemControl","indicator"],"defaultVariants":{"size":"md","variant":"solid"},"variantMap":{"size":["lg","md","sm","xl"],"variant":["outline","solid"]}}

export const radioButtonGroup = /* @__PURE__ */ createSlotRecipe(radioButtonGroupConfig)